import { matchValues } from '@shared/core/types/common';

const buttonFeel: OLO.Components.BUTTON_FEEL[] = ['plain', 'primary', 'secondary'];

export const buttonFeelType = matchValues(...buttonFeel);
